import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import {
  defaultGuestCertificatesDisclaimer,
  getDisclaimerText,
} from "common-client/utils/disclaimerOverrides";
import { DisclaimerName } from "../../../generated/graphql";
import { setTitle } from "../../../utils/title";
import { AuthContext } from "../../Authorization/AuthContext";
import { MarkdownContainer } from "../../Common/__styles__/MarkdownContainer";
import {
  ButtonWrapper,
  OptionsContainer,
} from "../../DocumentUploads/ElevationCertificates/__styles__/CertificatesTable";
import Layout from "../Layout";
import { PageSubheader } from "../PageSubheader";
import {
  accountTitle,
  HELPSCOUT_BEACON_TYPES,
  useHelpscoutBeacon,
} from "../utils";
import { CertificatesContainer } from "./__styles__/ElevationCertificates";
import ActionButton, { Props as ActionButtonProps } from "./ActionButton";
import { PublicFilesTable } from "./FilesTable";

const GuestActionsColumn = ({
  original,
}: {
  original: ActionButtonProps["documentUpload"];
}) => {
  return (
    <OptionsContainer>
      <ButtonWrapper>
        <ActionButton documentUpload={original} />
      </ButtonWrapper>
    </OptionsContainer>
  );
};

const ElevationCertificatesPage = () => {
  const { account, supportsElevationCertificates } = useContext(AuthContext);

  useHelpscoutBeacon(HELPSCOUT_BEACON_TYPES.EC);

  if (!supportsElevationCertificates) {
    return <Redirect to="/" />;
  }

  setTitle(`Elevation Certificates | ${accountTitle()}`);

  const disclaimerText = getDisclaimerText({
    disclaimerOverrides: account?.disclaimerOverrides,
    name: DisclaimerName.CERTIFICATE_PAGE,
    isPublic: true,
    defaultDisclaimers: {
      public: defaultGuestCertificatesDisclaimer({
        accountName: account?.name,
      }),
    },
  });

  return (
    <Layout hasGutters={true}>
      <PageSubheader title="Elevation Certificates">
        <p>
          Elevation Certificates document your property's flood risk. They are
          used for a variety of purposes, including tracking ordinance
          compliance and informing flood insurance.
        </p>
        <MarkdownContainer markdown={disclaimerText} />
      </PageSubheader>
      <CertificatesContainer>
        <PublicFilesTable actionCell={GuestActionsColumn} />
      </CertificatesContainer>
    </Layout>
  );
};

export default ElevationCertificatesPage;
